import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import client from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { Check, Crown } from "lucide-react";

export default function PaymentSuccess() {
    const [sp] = useSearchParams();
    const sessionId = sp.get("session_id");
    const { refresh } = useAuth();
    const [status, setStatus] = useState("pending");
    const [tx, setTx] = useState(null);

    useEffect(() => {
        if (!sessionId) return;
        let attempts = 0;
        const poll = async () => {
            attempts += 1;
            try {
                const { data } = await client.get(`/payments/status/${sessionId}`);
                setTx(data);
                if (data.payment_status === "paid") {
                    setStatus("paid");
                    refresh();
                    return;
                }
                if (data.status === "expired") {
                    setStatus("expired");
                    return;
                }
            } catch { /* retry */ }
            if (attempts < 8) setTimeout(poll, 2000);
            else setStatus("timeout");
        };
        poll();
    }, [sessionId]);

    return (
        <div className="min-h-[60vh] flex items-center justify-center px-6">
            <div className="bg-white border border-navy-100 rounded-3xl p-10 md:p-16 max-w-xl w-full text-center shadow-xl">
                {status === "paid" ? (
                    <>
                        <div className="mx-auto h-16 w-16 rounded-full bg-gold flex items-center justify-center">
                            <Check className="h-8 w-8 text-navy" strokeWidth={3} />
                        </div>
                        <div className="mt-4 inline-flex items-center gap-2 text-[11px] tracking-[0.25em] uppercase text-gold-700 font-semibold">
                            <Crown className="h-3.5 w-3.5" /> Premium Activated
                        </div>
                        <h1 className="mt-3 font-serif text-4xl text-navy tracking-tighter">Welcome to Premium</h1>
                        <p className="mt-3 text-navy-500 font-sans">${tx?.amount} {tx?.currency?.toUpperCase()} • Your sacred journey just got faster.</p>
                        <Link to="/dashboard" className="mt-8 inline-block font-sans text-xs uppercase tracking-[0.18em] bg-navy text-white rounded-lg px-8 py-4 hover:bg-navy-700 transition-all">
                            Go to Dashboard
                        </Link>
                    </>
                ) : status === "expired" || status === "timeout" ? (
                    <>
                        <h1 className="font-serif text-3xl text-navy">Payment {status === "expired" ? "Expired" : "Pending"}</h1>
                        <p className="mt-3 text-navy-500 font-sans">{status === "expired" ? "Your session expired. Please try again." : "Still processing… check your email for confirmation."}</p>
                        <Link to="/premium" className="mt-8 inline-block font-sans text-xs uppercase tracking-[0.18em] border border-navy-200 text-navy rounded-lg px-8 py-4 hover:bg-navy hover:text-white transition-all">Back to Plans</Link>
                    </>
                ) : (
                    <>
                        <div className="mx-auto h-10 w-10 rounded-full border-2 border-gold border-t-transparent animate-spin"></div>
                        <h1 className="mt-6 font-serif text-3xl text-navy">Confirming payment…</h1>
                        <p className="mt-3 text-navy-500 font-sans">Please don&rsquo;t close this tab.</p>
                    </>
                )}
            </div>
        </div>
    );
}
